document.addEventListener('DOMContentLoaded', function() {
    var originalButton = document.querySelector('.product-form__submit.button.button--full-width.button--primary');
    var infobar = document.querySelector('.im-product-infobar');
    var offersButton = document.querySelector('#offers'); // Select the button with id="offers"

    console.log('Original Button:', originalButton);
    console.log('Infobar:', infobar);
    console.log('Offers Button:', offersButton);

    if (originalButton && infobar) {
        // Intersection Observer to toggle visibility of infobar
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                console.log('Intersection entry:', entry);
                if (!entry.isIntersecting) {
                    console.log('Button is out of view, showing infobar');
                    infobar.classList.add('is-visible');
                } else {
                    console.log('Button is in view, hiding infobar');
                    infobar.classList.remove('is-visible');
                }
            });
        }, { threshold: 0 });

        observer.observe(originalButton);
    }

    // Scroll to the #offers section when the offers button is clicked
    if (offersButton) {
        offersButton.addEventListener('click', function(event) {
            event.preventDefault(); // Prevent default anchor behavior
            console.log('Offers button clicked, scrolling to #offers');
            
            // Scroll to the #offers section smoothly
            const offersSection = document.querySelector('#offers');
            if (offersSection) {
                offersSection.scrollIntoView({ behavior: 'smooth' });

                // Wait for the scroll to complete and remove the fragment from the URL
                setTimeout(function() {
                    history.replaceState(null, null, window.location.pathname); // Remove #offers from URL
                }, 1000); // Adjust the delay to match the scroll duration
            }
        });
    }
});
